













































































import { Vue, Component, Prop, p } from "av-ts";
import { IAvailability, IDay, ITime } from "../../interfaces/models";

interface IDayTimeIDs {
    day: number,
    time: number
};

@Component()
export default class AvailabilitySelector extends Vue {
    @Prop days = p<IDay[]>({
        default: () => {
            return [];
        }
    });

    @Prop times = p<ITime[]>({
        default: () => {
            return [];
        }
    })

    @Prop offeringDistribution = p<number[][]>({
        default: () => {
            return [];
        }
    });

    @Prop userDistribution = p<IAvailability[]>({
        default: () => {
            return [];
        }
    });

    @Prop maxAvailable = p<number>({
        default: () => {
            return 0;
        }
    });

    pShowAvailability = true;

    get showAvailability() {
        return this.pShowAvailability;
    }
    set showAvailability(newVal) {
        this.pShowAvailability = newVal;
    }

    checkbox(localDay: number, localTime: number) {
        const { day, time } = this.localToUTC(localDay, localTime);
        for (let i = 0; i < this.userDistribution.length; i++) {
            const entry = this.userDistribution[i];
            if (entry.day.id == day && entry.time.id == time) {
                return true;
            }
        }
        return false;
    }

    /**
    *   Converts a twenty four hour time to twelve hour with an "am" or "pm" suffix
    *   @param {number} time Twenty four hour time to convert to twelve hour
    *   @return {string} Twelve hour representation of time with "am" or "pm" suffix
    */
    twentyFourHourToTwelveHourPeriod(time: number): string {
        if (time == 12) {
            return `${time}pm`;
        } else if (time < 12) {
            return `${time}am`;
        }
        return `${time - 12}pm`;
    }

    checkboxChange(localDay: number, localTime: number) {
        const { day, time } = this.localToUTC(localDay, localTime);
        this.$emit("change", day, time);
    }

    addNewRow() {
        throw new Error("addNewRow not implemented");
    }

    deleteRow() {
        throw new Error("deleteRow not implemented");
    }

    getCellShade(localDay: number, localTime: number) {
        if (this.showAvailability) {
            let weight = 0;
            if (this.maxAvailable > 0) {
                const { day, time } = this.localToUTC(localDay, localTime);
                const offeringDistributionDay = this.offeringDistribution[day - 1];
                const entry = offeringDistributionDay[time - 1];
                weight = entry / this.maxAvailable;
            }
            // Perferably have a lookup table generated on mount
            return {
                background: `rgba(34, 85, 102, ${weight})`
            };
        }
    }

    convertDay(day?: number): number {
        if (day === undefined || this.days.length == 0) {
            throw new Error("Missing day");
        }
        if (day < 1) {
            return day + 7;
        } else if (day > 7) {
            return day - 7;
        } else {
            return day;
        }
    }

    convertTime(time?: number): number {
        if (time === undefined) {
            throw new Error("Missing day time");
        }

        if (time < 1) {
            return time + 24;
        } else if (time > 24) {
            return time - 24;
        } else {
            return time;
        }
    }

    localToUTC(localDay?: number, localTime?: number): IDayTimeIDs {
        if (localDay === undefined || localTime === undefined) {
            throw new Error("Missing localday or localtime");
        }

        const offset = new Date().getTimezoneOffset() / 60;
        let time = localTime + offset;
        let day = localDay;
        if (time < 1) {
            day--;
        } else if (time >= 24) {
            day++;
        }

        const dayTime: IDayTimeIDs = {
            day: this.convertDay(day),
            time: this.convertTime(time)
        };
        return dayTime;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/AvailabilitySelector.vue